import { ApiService } from '../../services/api_service';
import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import style from '../../default.less';
import formStyle from '../../core/forms/style/WForm.less';
import { Tour } from './Tour';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WFormFieldSelectOptAsSlider } from '../../core/forms/fields/WFormFieldSelectOptAsSlider';


interface StartWillkommenProps extends React.ClassAttributes<any> {
    data: any;
    onClose?: () => void;
    onRoutingChange: (routing: any) => void;
    hideInfo?: boolean;
}

interface StartWillkommenState {
    showTour: boolean;
    showStartHinweis: boolean;
    newsletterAbo: number;
    regiTid: number;
    nutzungsmodusStandard: number;
    nutzungsmodusExpert: number;
}
export class StartWillkommen extends React.Component<StartWillkommenProps, StartWillkommenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showTour: false,
            showStartHinweis: false,
            newsletterAbo: null,
            regiTid: null,
            nutzungsmodusStandard: null,
            nutzungsmodusExpert: null
        };
        this.toggleKonfig = this.toggleKonfig.bind(this);
        this.onChangeGefuehrterModus = this.onChangeGefuehrterModus.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private autoClose = true;

    componentDidMount() {
        const showStartHinweis: boolean = !!((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .filter((param: any) => (param.start_hinweis || null) === 'Ja').length);

        const modusData = (this.props.data[IDs.ENT_KONFIGURATION] || [])[0];
        const gefuehrter_modus = modusData.gefuehrter_modus_orig || modusData.gefuerter_modus || 0;

        this.setState({ showStartHinweis, nutzungsmodusStandard: gefuehrter_modus, nutzungsmodusExpert: Math.abs(gefuehrter_modus - 1) });

        let regiTid: number;
        if (this.apiService.isAdmin() || this.apiService.isBerater() || this.apiService.userHasMultiTools()) {
            regiTid = (this.props.data[IDs.ENT_REGISTRIERUNG][0] || {}).tid;
        } else {
            regiTid = this.apiService.getUserTid();
        }
        if (regiTid > 0) {
            this.setState({ regiTid });
            this.dataService.loadData(IDs.ENT_REGISTRIERUNG, { tid: regiTid }, null, (res: any) => {
                if (res && res[IDs.ENT_REGISTRIERUNG]) {
                    const newsletter_abo = (res[IDs.ENT_REGISTRIERUNG][0] || {}).newsletter_abo;
                    this.setState({ newsletterAbo: newsletter_abo === 1 ? 1 : 0 });
                }
            }, IDs.MOD_ETOOL_ADMIN);
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const showStartHinweisPre: boolean = !!((prevProps.data[IDs.ENT_KONFIGURATION] || [])
            .filter((param: any) => (param.start_hinweis || null) === 'Ja').length);
        const showStartHinweis: boolean = !!((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .filter((param: any) => (param.start_hinweis || null) === 'Ja').length);
        if (showStartHinweisPre !== showStartHinweis) {
            this.setState({ showStartHinweis });
        }
    }

    delKonto(): void {
        alert(
            `Wenn Sie das E-Tool löschen werden alle eingegebenen Daten entfernt und gehen verloren.\n
            Diese Vorgang kann nicht rückgängiggemacht werden.`
        );

        if (!confirm('Wollen Sie Ihre E-Tool-Registrierung mit allen dazugehörigen Daten unwiderruflich löschen?')) {
            return;
        }
        const mandant_key: string = this.apiService.getMandantKey();
        const user_tid: number = this.apiService.getUserTid();
        const delData = (tid: number) => {
            this.dataService.delData(IDs.ENT_REGISTRIERUNG, IDs.MOD_ETOOL_ADMIN, { tid }, {}, (res: any, suc: boolean) => {
                this.triggerService.fire('reload', IDs.ENT_REGISTRIERUNG);
                document.cookie = 'access_token= ; path=/';
                const currentPage = new URL(window.location.href);
                currentPage.searchParams.set('t', ((new Date().getTime()).toString()));
                window.location.href = currentPage.href;
            });
        };
        if ((this.apiService.isAdmin() || this.apiService.isBerater() || this.apiService.userHasMultiTools()) && mandant_key) {
            this.dataService.loadData(
                IDs.ENT_REGISTRIERUNG, { mandant_key },
                { fieldList: 'tid' },
                (data: any) => {
                    const tid: number = +((data[IDs.ENT_REGISTRIERUNG] || [])[0] || {}).tid || null;
                    if (tid) {
                        delData(tid);
                    }
                },
                IDs.MOD_ETOOL_ADMIN
            );
        } else if (!this.apiService.isAdmin() && !this.apiService.isBerater() && user_tid) {
            delData(user_tid);
        } else {
            alert('Das Konto konnte nicht gelöscht werden.');
        }
    }

    onChangeGefuehrterModus(value: number): void {
        const data = this.props.data;
        if (Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0) {
            const item: any = {
                tid: this.props.data[IDs.ENT_KONFIGURATION][0].tid,
                show_gefuehrter_modus: false,
                gefuehrter_modus: value
            };
            this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION, item, () => {
                this.triggerService.fire('reload', IDs.ENT_KONFIGURATION);
                const path = {
                    selectedMenu: RoutingIDs.MENUE_DATENEINGABE,
                    [RoutingIDs.TABS_DATENEINGABE]: RoutingIDs.TAB_DATENEINGABE_BETRIEBLICHE_DATEN,
                    terminateOn: RoutingIDs.TABS_DATENEINGABE_BETRIEBLICHE_DATEN
                };
                this.props.onRoutingChange({ path });
                if (this.autoClose && this.props.onClose) {
                    this.props.onClose();
                }
            });
        }
    }

    render(): JSX.Element {
        const options: Array<any> = [
            { label: 'Ja', value: 1 },
            { label: 'Nein', value: 0 }
        ];
        return (
            <div className={formStyle.flowV2} style={{ backgroundColor: 'white', paddingRight: 30 }}>
                <div className={formStyle.formcontainer} style={{}}>
                    <div style={{ borderBottom: this.props.hideInfo ? '1px solid #918f8f' : 'none', paddingBottom: '20px', marginBottom: '20px', width: '100%' }}>
                        {!this.props.hideInfo && this.renderTextNew()}
                        {this.props.hideInfo &&
                            <div style={{ fontSize: '14pt', marginBottom: '10px', fontWeight: 'bold' }}>
                                Nutzungsmodus
                            </div>
                        }
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '10px' }}>
                            <WFormFieldSelectOptAsSlider
                                label={null}
                                value={{ value: this.state.nutzungsmodusStandard }}
                                options={options}
                                horizontal
                                disabled={false}
                                onChange={(opt: any) => {
                                    this.setState({
                                        nutzungsmodusStandard: opt.value,
                                        nutzungsmodusExpert: Math.abs(+opt.value - 1)
                                    }, () => {
                                        this.onChangeGefuehrterModus(this.state.nutzungsmodusStandard === 1 ? 1 : 2);
                                    });

                                }}
                            />
                            <span style={{ fontWeight: 'bold', margin: '0 5px' }}>Standardmodus:</span> Sie werden Schritt für Schritt durch die Dateneingabe geführt.
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '10px' }}>
                            <WFormFieldSelectOptAsSlider
                                label={null}
                                value={{ value: this.state.nutzungsmodusExpert }}
                                options={options}
                                horizontal
                                disabled={false}
                                onChange={(opt: any) => {
                                    this.setState({
                                        nutzungsmodusExpert: opt.value,
                                        nutzungsmodusStandard: Math.abs(+opt.value - 1)
                                    }, () => {
                                        this.onChangeGefuehrterModus(this.state.nutzungsmodusStandard === 1 ? 1 : 2);
                                    });

                                }}
                            />
                            <span style={{ fontWeight: 'bold', margin: '0 5px' }}>Expertenmodus:</span> Sie können die Dateneingabe in freier Reihenfolge vornehmen.
                        </div>
                    </div>

                    {this.props.hideInfo &&
                        <div style={{ borderBottom: '1px solid #918f8f', paddingBottom: '20px', marginBottom: '20px', width: '100%' }}>
                            <div style={{ fontSize: '14pt', marginBottom: '10px', fontWeight: 'bold' }}>
                                Newsletter
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', marginBottom: '10px' }}>
                                <WFormFieldSelectOptAsSlider
                                    label={null}
                                    value={{ value: this.state.newsletterAbo }}
                                    options={options}
                                    horizontal
                                    disabled={false}
                                    onChange={(opt: any) => {
                                        this.setState({
                                            newsletterAbo: opt.value
                                        }, () => {
                                            if (this.state.regiTid > 0) {
                                                this.dataService.saveData(IDs.ENT_REGISTRIERUNG, { tid: this.state.regiTid, newsletter_abo: this.state.newsletterAbo }, null, null, (suc: boolean, saveTid: number) => {
                                                    this.triggerService.fire('reload', IDs.ENT_REGISTRIERUNG);
                                                }, IDs.MOD_ETOOL_ADMIN,);
                                            }
                                        });

                                    }}
                                />
                                <div style={{ margin: '0 5px' }}>
                                    <span style={{ marginRight: '5px', fontWeight: 'bold' }}>Newsletter / Info-Mails empfangen:</span>
                                    Deaktivieren Sie den Schieber, wenn Sie zukünftig keine Mails/Nachrichten mehr über das E-Tool empfangen möchten.
                                </div>
                            </div>
                        </div>
                    }

                    {this.props.hideInfo &&
                        <div style={{ paddingBottom: '20px', marginBottom: '20px', width: '100%' }}>
                            <div style={{ fontSize: '14pt', marginBottom: '10px', fontWeight: 'bold' }}>
                                Nutzerkonto löschen
                            </div>
                            <div>
                                Wenn Sie das E-Tool zukünftig nicht mehr nutzen möchten, können Sie hier Ihre Registrierung und die zugehörigen Daten löschen. Damit das Löschen nicht unbeabsichtigt erfolgt, ist mehrfaches Bestätigen erforderlich.
                            </div>
                            {this.renderKontoloeschungNew()}
                        </div>
                    }
                </div>

                {this.state.showTour &&
                    <div>
                        <DialogWrapper2
                            onAfterClose={() => this.setState({ showTour: false })}
                        >
                            <Tour />
                        </DialogWrapper2>
                    </div>
                }

            </div>
        );
    }

    renderOld(): JSX.Element {
        return (
            <div style={{ flex: 1, flexDirection: 'row', display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                <div style={{ padding: 20, color: '#888', maxWidth: 550, textAlign: 'justify' }}>
                    {!this.props.hideInfo && this.renderTextNew()}
                    {this.props.hideInfo &&
                        <b style={{ marginBottom: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                            Nutzungsmodus
                        </b>
                    }
                    {this.renderButtons()}
                    <div style={{ marginTop: 15, fontFamily: 'calibri', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {this.props.hideInfo
                            ? <span style={{ fontFamily: 'calibri' }}>Hinweis-Dialog bei jedem Start anzeigen</span>
                            : <span style={{ fontFamily: 'calibri' }}>Diesen Hinweis bei jedem Start anzeigen</span>
                        }
                        <input
                            type='checkbox'
                            checked={this.state.showStartHinweis}
                            onChange={(evt: any) => {
                                this.setState({ showStartHinweis: evt.target.checked });
                                this.toggleKonfig(evt.target.checked ? 1 : 2);
                            }}
                        />
                    </div>
                    {this.props.hideInfo && this.renderNewsletterAbo()}
                    {this.props.hideInfo && this.renderKontoloeschung()}
                </div>
                {this.state.showTour &&
                    <div>
                        <DialogWrapper2
                            onAfterClose={() => this.setState({ showTour: false })}
                        >
                            <Tour />
                        </DialogWrapper2>
                    </div>
                }
            </div>
        );
    }

    renderTextNew() {
        const img = require('../../img/start_info.jpg');
        return (
            <img
                src={img}
                style={{ maxWidth: 560 }}
                onClick={(evt: any) => {
                    const rect = evt.target.getBoundingClientRect();
                    const x = evt.clientX - rect.left;
                    const y = evt.clientY - rect.top;
                    console.log(x, y);
                    if (x > 510 && x < 555 && y > 430 && y < 450) {
                        // alert('Diese Funktion steht Ihnen in Kürze zur Verfügung!');
                        this.setState({ showTour: true });
                    }
                }}
            />
        );
    }

    renderButtons() {
        const gefuehrter_modus = this.props.data[IDs.ENT_KONFIGURATION].length > 0
            ? this.props.data[IDs.ENT_KONFIGURATION][0].gefuehrter_modus_orig
            : 0;

        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        // alert('Bereich: ' + bereich_key);
        const exp_name = bereich_key === 'kultur' ? 'Expert:innenmodus' : 'Expertenmodus';
        return (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                <button className={style.basic} onClick={() => this.onChangeGefuehrterModus(1)}
                    style={{
                        fontSize: 14, width: 200,
                        border: gefuehrter_modus === 1 && '2px solid #6692c3'
                    }}
                >
                    <b>Standardmodus</b>
                    <div style={{ fontSize: 11, fontStyle: 'italic', marginTop: 5 }}>
                        Sie werden Schritt für Schritt durch die Dateneingabe geführt.
                    </div>
                </button>
                <button className={style.basic} onClick={() => this.onChangeGefuehrterModus(2)}
                    style={{
                        fontSize: 14, width: 200,
                        border: gefuehrter_modus !== 1 && '2px solid #6692c3'
                    }}
                >
                    <b>{exp_name}</b>
                    <div style={{ fontSize: 11, fontStyle: 'italic', marginTop: 5 }}>
                        Sie können die Dateneingabe in freier Reihenfolge vornehmen.
                    </div>
                </button>
            </div>
        );
    }

    renderNewsletterAbo(): JSX.Element {
        if (this.state.newsletterAbo === null) {
            return null;
        }
        return <div style={{ marginTop: 20, borderTop: '2px solid #888' }}>
            <div style={{ marginTop: 15, fontFamily: 'calibri', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontFamily: 'calibri' }}>Keine Newsletter/Info-Mails empfangen</span>
                <input
                    type='checkbox'
                    checked={this.state.newsletterAbo !== 1}
                    onChange={(evt: any) => {
                        const newsletterAbo = this.state.newsletterAbo === 0 ? 1 : 0;
                        this.setState({ newsletterAbo });
                        if (this.state.regiTid > 0) {
                            this.dataService.saveData(IDs.ENT_REGISTRIERUNG, { tid: this.state.regiTid, newsletter_abo: newsletterAbo }, null, null, (suc: boolean, saveTid: number) => {
                                this.triggerService.fire('reload', IDs.ENT_REGISTRIERUNG);
                            }, IDs.MOD_ETOOL_ADMIN,);
                        }
                    }}
                />
            </div>
        </div>;
    }

    renderKontoloeschung(): JSX.Element {
        return (
            <>
                <div style={{ fontFamily: 'calibri', textAlign: 'center', marginTop: 20, paddingTop: 20, borderTop: '2px solid #888' }}>
                    <b style={{ marginBottom: 10, display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                        E-Tool Nutzerkonto löschen
                    </b>
                    <span style={{ fontFamily: 'calibri' }}>
                        Wenn Sie das E-Tool zukünftig nicht mehr nutzen möchten, können Sie hier Ihre Registrierung und die zugehörigen
                        Daten löschen. Damit das Löschen nicht unbeabsichtigt erfolgt, ist  mehrfaches Bestätigen erforderlich.
                    </span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                    <button
                        className={style.basic}
                        style={{ fontSize: 14, color: '#a77', width: 200, backgroundColor: '#fee', border: '1px solid #a77' }}
                        onClick={() => this.delKonto()}
                    >
                        <b>E-Tool Nutzerkonto jetzt löschen</b>
                    </button>
                </div>
            </>
        );
    }

    renderKontoloeschungNew(): JSX.Element {
        return (
            <button
                className={style.basic}
                style={{ fontSize: 14, color: '#a77', width: 200, backgroundColor: '#fee', margin: '18px 0 0', border: '1px solid #a77' }}
                onClick={() => this.delKonto()}
            >
                <b>E-Tool Nutzerkonto jetzt löschen</b>
            </button>
        );
    }

    toggleKonfig(value: number): void {
        const data = this.props.data;
        if (Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0) {
            const item: any = {
                tid: data[IDs.ENT_KONFIGURATION][0].tid,
                start_hinweis: value
            };
            this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION, item, () => {
                this.triggerService.fire('reload', IDs.ENT_KONFIGURATION);
            });
        }
    }
}
